import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
const TTSBillingProvider = lazy(()=> import(/* webpackChunkName: "TTSBillingProvider" */'./components'));

const routes = () => (
    <PrivateRoute exact path="/settings/tts-provider-billing" component={TTSBillingProvider} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/TTSBillingProvider/routes.js